// extracted by mini-css-extract-plugin
export default {"title":"List_title__ZjuBo","table":"List_table__bDiLq","wrapper":"List_wrapper__HBHEP"};